import React from 'react';
import DragAndDrop from '../DragAndDrop/DragAndDrop';

export const CopyList = (props) => {
    return <DragAndDrop
        {...props}
        type='copy'
        containerClass="draggable-list"
         />;
};



//contains section content, be it a header, a footer or a body (content)
export const SortableList = (props) => {
    return <DragAndDrop
        {...props}
        containerClass="sortable-list"
        />;
};




// WEBPACK FOOTER //
// ./src/components/HOCs/withDragAndDrop.js